import { fetchEmployeesApi } from 'src/services/employees.service.js';
import { fetchNewEmployeeFormData, saveEmployeeFormData } from 'src/services/serviceinit.service.js';
import { fetchEmployersLookupValues, getNewEmployerForm, createEmployer } from 'src/services/accounts.service.js';

export const NEW_DASHBOARD_URL = '/new-dashboard';
export const DOCUMENTS_URL = '/documents';
export const DUAL_ROLE_PICK_URL = '/select-role';
export const CONSENT_URL = '/consent';
export const PROFILE_URL = '/profile';
export const HOME_URL = '/home';
export const MESSAGING_URL = '/messages';
export const MESSAGING_COMPOSE_URL = '/messages/compose';
export const MESSAGING_COMPOSE_AUTOFILL_URL = `${MESSAGING_COMPOSE_URL}/:entityType/:contactId/:caseId`;
export const LOGIN_URL = '/';
export const LOGOUT_URL = '/?logout';
export const LOGOUT_URL2 = '/logout';
export const CASES_URL = '/cases';
export const CASE_DETAIL_URL = '/cases/detail';
export const QUESTIONNAIRE_URL = '/questionnaire';
export const QUESTIONNAIRE_LANDING_URL = `${QUESTIONNAIRE_URL}/:entityId/:organizerTypeId/:yearTypeId/:languageId`;
export const QUESTIONNAIRE_PAGE_URL = `${QUESTIONNAIRE_LANDING_URL}/:sectionName/:pageId`;
export const QUESTIONNAIRE_PAGE_URL_SIMPLE = `${QUESTIONNAIRE_URL}/:entityId`;
export const CASE_DETAIL_QUESTIONNAIRE_URL = `${CASE_DETAIL_URL}/:caseId${QUESTIONNAIRE_URL}`;
export const CASE_DETAIL_QUESTIONNAIRE_LANDING_URL = `${CASE_DETAIL_QUESTIONNAIRE_URL}/:assigneeServicePlanGlobalId/:organizerTypeId/:yearTypeId/:languageId`;
export const CASE_DETAIL_QUESTIONNAIRE_SECTION_URL = `${CASE_DETAIL_QUESTIONNAIRE_LANDING_URL}/:sectionName`;
export const DOCUMENTS_DETAIL_URL = '/documents/detail';
export const DOC_UPLOAD_NEW_URL = '/documents/upload-new';
export const SERVICEINIT_URL = '/ssi';
export const SERVICEINIT_LANDING_URL = `${SERVICEINIT_URL}`;
export const SERVICEINIT_URL_ADDSI = `${SERVICEINIT_URL}/add`;
export const SERVICEINIT_URL_BATCHSI = `${SERVICEINIT_URL}/batch`;
export const SERVICEINIT_PAGE_URL = `${SERVICEINIT_URL_ADDSI}/:pageId`;
export const SERVICEINIT_DETAILS_URL = `${SERVICEINIT_URL}/details/:serviceInitiationId`;
export const BATCHINIT_URL = '/bsi';
export const HELP_URL = '/help';
export const TASK_DETAIL_URL = '/tasks/detail/:taskId';
export const EMPLOYEES_URL = '/employees';
export const EMPLOYEES_TEAM_URL = '/employees/team';
export const ASSIGNMENTS_URL = '/assignments';
export const ASSIGNMENTS_DETAIL_URL = '/assignments/detail/:assignmentId';
//Case data collect
export const CASE_DATA_COLLECT_COMPOSE_URL = '/case-data';
export const CASE_DATA_COLLECT_URL = `${CASE_DATA_COLLECT_COMPOSE_URL}/:caseId/:sectionId/:pageId`;
export const DOCUMENTS_CASE_COMPOSE_URL = '/documents/case';
export const DOCUMENTS_CASE_URL = `${DOCUMENTS_CASE_COMPOSE_URL}/:caseId`;

// WhatIf
export const WHAT_IF_URL = '/whatif';
export const WHAT_IF_RESULTS_URL = '/whatif/results';
export const WHAT_IF_RESULTS_DETAIL_URL = '/whatif/results/detail/:resultIndex';
export const WHAT_IF_RESULTS_COMPARE_URL = '/whatif/results/compare';
export const WHAT_IF_RESULTS_EXCEL_URL = '/whatif/results/excel';

export const EMPLOYEE_DETAIL_URL = '/employees/detail/:employeeId';
export const EMPLOYEE_TEAM_DETAIL_URL = '/employees/team/detail/:employeeId';
export const FORGOT_PASSWORD = '/ForgotPassword';
export const TWO_FACTOR = '/TwoFactor';
export const INVALID_TOKEN = 'Invalid Token';

export const LANGUAGES = {
  EN_US: 'en-us',
  DE: 'de',
};

export const NEW_DASHBOARD_ROUTES = {
  NEW_DASHBOARD_URL,
  PROFILE_URL,
  MESSAGING_URL,
  DOCUMENTS_URL,
  DOCUMENTS_CASE_URL,
  SERVICEINIT_URL,
  EMPLOYEES_URL,
  CASE_DETAIL_URL,
};

/* Routes allowed per user roles */
export const SECURITY_ROUTES = {
  corpClient: [
    NEW_DASHBOARD_URL,
    MESSAGING_URL,
    PROFILE_URL,
    CONSENT_URL,
    DOCUMENTS_URL,
    LOGIN_URL,
    CASES_URL,
    PROFILE_URL,
    QUESTIONNAIRE_URL,
    SERVICEINIT_URL,
    HELP_URL,
    EMPLOYEES_URL,
    FORGOT_PASSWORD,
    TWO_FACTOR,
    HOME_URL,
    WHAT_IF_URL,
    ASSIGNMENTS_URL,
    CASE_DATA_COLLECT_COMPOSE_URL,
  ],
  applicant: [
    NEW_DASHBOARD_URL,
    MESSAGING_URL,
    CONSENT_URL,
    LOGIN_URL,
    DOCUMENTS_URL,
    CASES_URL,
    CASE_DETAIL_URL,
    QUESTIONNAIRE_URL,
    HELP_URL,
    PROFILE_URL,
    FORGOT_PASSWORD,
    TWO_FACTOR,
    WHAT_IF_URL,
    CASE_DATA_COLLECT_COMPOSE_URL,
  ],
  restrictedCorpMember: [
    NEW_DASHBOARD_URL,
    MESSAGING_URL,
    CONSENT_URL,
    LOGIN_URL,
    DOCUMENTS_URL,
    CASES_URL,
    CASE_DETAIL_URL,
    QUESTIONNAIRE_URL,
    HELP_URL,
    PROFILE_URL,
    FORGOT_PASSWORD,
    TWO_FACTOR,
    SERVICEINIT_DETAILS_URL,
    ASSIGNMENTS_DETAIL_URL,
    CASE_DATA_COLLECT_COMPOSE_URL,
  ],
};

export const PRIORITY = {
  HIGH: 'High Priority',
  NORMAL: 'Normal Priority',
};

export const FORM_MODE = {
  ADD: 'Add',
  EDIT: 'Edit',
  VIEW: 'View',
  CLOSE: 'Close',
};

export const BODY_CLASSES = {
  CONSENT: 'consent',
  DOCUMENTS: 'documents',
  LOGIN: 'login',
  HOME: 'home',
  MESSAGING: 'messaging',
  CASES: 'cases',
  CASE_DETAILS_APPLICANT: 'case-details-applicant',
  QUESTIONNAIRE: 'questionnaire',
  ADMIN: 'admin',
  SERVICEINIT: 'serviceinit',
  HELP: 'help',
  ENGAGEMENTS: 'engagements',
  USERS: 'users',
  TASKS: 'tasks',
  EMPLOYEES: 'employees',
  ASSIGNMENTS: 'assignments',
};

/* TIMER TYPES */
export const TIMER_START = '[TIMER][START] Starting interval timer';
export const TIMER_RUNNING = '[TIMER][RUNNING] Running interval timer';
export const TIMER_STOP = '[TIMER][STOP] Stopping interval timer';
export const TIMER_TYPES = {
  MESSAGING: 'messagingMonitor',
  DASHBOARD_COUNTS_MONITOR: 'dashboardCountsMonitor',
  GLOBAL_COUNTS_MONITOR: 'globalCountsMonitor',
};

export const MAX_ATTEMPTS = 3;

/* MESSAGING CONSTANTS */
export const MESSAGE_PREVIEW_CHARLIMIT = 150;
export const MSG_MONITOR_INTERVAL = 1000 * 180; // 3 minutes

export const AUTOCOMPLETE_MESSAGING_EMAIL_LIMIT = 5;
export const AUTOCOMPLETE_MESSAGING_CASES_LIMIT = 500;

export const MESSAGEBOX_TYPES = {
  INBOX: 'inbox',
  SENT: 'sent',
  DRAFT: 'draft',
};

export const MESSAGEBOX_VIEWS = {
  NAVIGATION: 'NAVIGATION',
  LIST: 'LIST',
  DETAILS: 'DETAILS',
};

export const MESSAGEDETAIL_TYPES = {
  VIEWMESSAGE: 'VIEWMESSAGE',
  COMPOSE: 'COMPOSE',
  DRAFT: 'DRAFT',
  FORWARD: 'FORWARD',
  REPLY: 'REPLY',
  REPLY_TO_ALL: 'REPLY_TO_ALL',
};

export const MESSAGEORDER_TYPES = {
  ASC: 'asc',
  DESC: 'desc',
};

//fields for filtering
export const CASES_FILTERS = {
  ENGAGEMENTS: 'ENGAGEMENTS',
  ENTITY: 'ENTITY',
  PATHWAY: 'PATHWAY',
  DAYSOLD: 'DAYSOLD',
};

export const TITLES = {
  COMPOSE: 'Compose new message',
  FORWARD: 'Forward message',
  REPLY: 'Reply to message',
  REPLY_TO_ALL: 'Reply to all',
};

export const noData = {
  type: 'nodata',
};

export const MAX_ATTACHMENT_SIZE = 15000000;

export const ATTACHMENT_TYPES = [
  { type: '.ZIP', icon: 'file' },
  { type: '.KEY', icon: 'file' },
  { type: '.CER', icon: 'file' },
  { type: '.XLS', icon: 'excel' },
  { type: '.PDF', icon: 'pdf' },
  { type: '.JPG', icon: 'image' },
  { type: '.BMP', icon: 'image' },
  { type: '.TIF', icon: 'image' },
  { type: '.DOC', icon: 'word' },
  { type: '.TXT', icon: 'document' },
  { type: '.DOCX', icon: 'word' },
  { type: '.DOCM', icon: 'word' },
  { type: '.DOTX', icon: 'word' },
  { type: '.DOTM', icon: 'word' },
  { type: '.XLSX', icon: 'excel' },
  { type: '.XLSM', icon: 'excel' },
  { type: '.XLTX', icon: 'excel' },
  { type: '.XLTM', icon: 'excel' },
  { type: '.XLSB', icon: 'excel' },
  { type: '.XLAM', icon: 'excel' },
];

export const CMS_ATTACHMENT_TYPES = [
  { type: '.ZIP', icon: 'file' },
  { type: '.XML', icon: 'file' },
  { type: '.XSLT', icon: 'file' },
];

export const TABLE_STATUS = {
  initialize: 'initialize',
  ready: 'ready',
  loading: 'loading',
};

export const IDLE_TIMEOUT = 20 * 60000;
export const INIT_COUNT = 60;
export const DEBOUNCE_SEARCH = 300;

export const SI_ADDINITIATION_VIEWTYPES = {
  SELECT_SERVICETYPE: 'SELECT_SERVICETYPE',
  BATCH_UPLOAD: 'BATCH_UPLOAD',
  ADD_APPLICANT: 'ADD_APPLICANT',
  ADD_LINEMANAGER: 'ADD_LINEMANAGER',
  DYNAMIC_CONTENT: 'DYNAMIC_CONTENT', // Parser/API kicks in here
};

export const SI_INITIATION_TYPES = {
  BATCH_INITIATION: 1783,
  MANUAL_INITIATION: 1782,
};

export const DOC_UPLOAD_TYPES = {
  PROFILE: 1,
  CASE: 2,
};

export const SI_ADD_APPLICANT_VIEWS = {
  SEARCH: 'SEARCH',
  ADDNEW: 'ADDNEW',
};

export const SI_ADD_LINEMANAGER_VIEWS = {
  SEARCH: 'SEARCH',
  ADDNEW: 'ADDNEW',
};

export const SI_MENU_PAGESTATES = {
  COMPLETE: 'Complete',
  CURRENT_COMPLETE: 'CurrentComplete',
  NOT_VISITED: 'Not_Visited',
  CURRENT_NOT_COMPLETE: 'CurrentNotComplete',
};

export const CREATEORGANIZER_PAGESTATES = {
  COMPLETE: 83, // only 83,84 seem to work?
  INCOMPLETE: 84,
  NOT_VISITED: 85,
  CURRENT_NOT_COMPLETE: 86,
  CURRENT_COMPLETE: 94,
  ENTITY_HEADER: 89,
};

export const USER_ROLES = {
  EY_PROFESSIONAL: 'EY Pro',
  CORPORATE_CLIENT: 'Corporate client',
  APPLICANT: 'Applicant',
};

// deprecate this later.
export const validRoleCodes = [
  {
    roleKey: 100,
    roleType: 'eyPro',
  },
  {
    roleKey: 120,
    roleType: 'corpClient',
  },
  {
    roleKey: 130,
    roleType: 'applicant',
  },
  {
    roleKey: 140,
    roleType: 'eyAdmin',
  },
  {
    roleKey: 150,
    roleType: 'eyEngagementAdmin',
  },
  {
    roleKey: 160,
    roleType: 'corporateClientlineManager',
  },
  {
    roleKey: 170,
    roleType: 'restrictedCorpMember',
  },
];

export const ROLE_KEYS = {
  EYPRO: 100,
  CORP_CLIENT: 120,
  APPLICANT: 130,
  EYADMIN: 140,
  CORP_CLIENT_LINEMANAGER: 160,
};

export const DASHBOARD_TYPES = {
  NEW_MESSAGES: 'newMessages',
};

// these could be a duplicate of the SSI
// for now we will keep it duplicated until app is complete and we can condense
// unsure if there will be differences between the two (SSI/Applicant)
export const APPLICANT_MENU_PAGESTATES = {
  COMPLETE: 'Complete',
  CURRENT_COMPLETE: 'CurrentComplete',
  NOT_VISITED: 'Not_Visited',
  CURRENT_NOT_COMPLETE: 'CurrentNotComplete',
};

export const FILE_UPLOAD_ERRORS = {
  LIMIT_EXCEEDED: 'limitExceeded',
  UNSUPPORTED: 'unsupported',
};

export const SYSTEM_ROLES = {
  APPLICANT: 'APPLICANT', //130, // 'Applicant',
  CORP_CLIENT: 'CORPCLI', //120, //'Corp Client',
  EY_ADMINISTRATOR: 'EYADMIN', //140, //'EY Administrator',
  EY_PRO: 'EYPRO', //100, //'EY Pro',
  EY_ENGAGEMENT_ADMINISTRATOR: 'EY_ENG_ADMIN', //150, //'EY Engagement Administrator',
  CORPORATE_CLIENT_LINE_MANAGER: 'CC_LN_MNGR', //160, //'Corporate Client Line Manager',
};

export const DOCUMENT_READ_ONLY_TYPES_FOR_EXT_USERS = [
  'Acknowledgement of filing application from immigration authorities',
  'Certificate of Coverage',
  'Final NIV Date',
  'US Priority Date',
  'Notification',
  'Notification of intention to cancel visa from immigration authorities',
  'Receipts',
  'Visa',
  'Work Permit',
  'Visa Decision notification from immigration authorities',
  'Residency Card',
  'Request for further information from immigration authorities',
];

export const DOCUMENT_SUPPORTED_FILES = [
  '.BMP',
  '.JPEG',
  '.JPG',
  '.PNG',
  '.TIF',
  '.PDF',
  '.DOC',
  '.DOCX',
  '.DOCM',
  '.DOTX',
  '.DOTM',
  '.XLS',
  '.XLSX',
  '.XLSM',
  '.XLTX',
  '.XLTM',
  '.XLSB',
  '.XLAM',
];

export const BATCHINITIATION_SUPPORTED_FILES = ['.XLSX'];

export const DOCUMENT_UPLOAD_TOTAL_MAX_SIZE = 104857600; //15MB

export const DOCUMENT_UPLOAD_MAX_NUM = 5;

// any macros (ie: #variable#) need to be provided from the component it's intialized from
// example: this.props.addToHistory(window.location.pathname, { id: this.getCaseManagerId() });
export const HISTORY_URL_MAPPER = {
  '/ssi': 'Service Initiation',
  '/bsi': 'Batch Initiation',
  '/ssi/add': 'Add Initiation',
  '/ssi/add/#id#': 'Service Initiation - ID #id#',
  '/documents': 'Documents',
  '/documents/detail/#caseId#/#documentId#/#documentKey#': 'Document Details - ID: #documentId#',
  '/messages': 'Messages',
  '/messages/compose': 'Compose Message',
  '/documents/upload-new/': 'Upload Documents',
  '/help': 'Help',
  '/cases/detail/#id#': 'Case Details - ID #id#',
  '/admin/uploads': 'CMS Uploads',
  '/admin/engagements': 'Engagement Management',
  '/admin/engagements/details': 'Engagement Details',
  '/admin/users': 'User Management',
  '/admin/upload-new': 'Upload CMS Packages',
  '/tasks': 'Tasks',
};

export const DATE_INPUT_STYLE_TYPES = {
  SERVICE_INITIATION: 'serviceInitation',
};

export const CASES_QUESTIONNAIRE_ACTION_TYPES = {
  DOWNLOAD_PREPROFORMA_XML: 'casesQuestionnaireActionTypes/DOWNLOAD_PREPROFORMA_XML',
  DOWNLOAD_ANSWERKEY_XML: 'casesQuestionnaireActionTypes/DOWNLOAD_ANSWERKEY_XML',
  OPEN_WORKPAPER: 'casesQuestionnaireActionTypes/OPEN_WORKPAPER',
};

export const TASK_STATUS = {
  OPEN: 'Incomplete',
  COMPLETED: 'Complete',
  NOT_VISITED: 'Open',
  COMPLETE: 'Completed',
};

export const WORK_PAPER = {
  PRODUCT_TYPE_AB: 'IMM',
  COUNTRY_AB: 'AB',
};

export const REQUEST_STATUS = {
  PENDING: 'request is pending',
  SUCCESS: 'request is successfull',
  FAILED: 'request failed',
};

export const LAUNCH_ADOBE = false;

export const CASES_TRACK_STATUS = {
  onTrack: 100000000,
  atRisk: 100000001,
  offTrack: 100000002,
};
export const MARITAL_STATUS = {
  married: '100000001',
  divorcee: '100000003',
};
export const END_DATE_STATUS = {
  yes: '100000000',
  no: '100000001',
};
export const RELATIONSHIP_CONSTANTS = {
  expiration: 'ey_doesthisrecordhaveanexpirationdate',
  doesThisRecordHaveEndDate: 'ey_doesthisrecordhaveenddate',
  endDate: 'ey_effectiveenddate',
  endDateValue: 'ey_enddate',
  maritalStatus: 'ey_maritalstatus',
  dateOfMarriage: 'ey_dateofmarriage',
  dateOfDivorce: 'ey_dateofdivorce',
  relationshiptype: 'ey_relationshiptype',
};
export const SI_BATCH_SUPPORTED_FILES = ['.XLSX'];
export const SI_BATCH_UPLOAD_TOTAL_MAX_SIZE = 15728640; //15MB
export const SI_BATCH_PROGRESS_INTERVAL = 2000; // 2 seconds

export const COOKIES = {
  STATUS: '_ey_pathway_status',
  ENTRY_PATH: '_ey_pathway_entrypath',
};

export const DOCUMENTS_FAST_FILTERS = {
  isExpiring: 'isExpiring',
  expired: 'recentlyExpired',
};

export const PROFILE_RELATED_ENTITIES = {
  contactAddresses: 'contactAddresses',
  contactCitizenships: 'contactCitizenships',
  contactIdentificationNumbers: 'contactIdentificationNumbers',
  contactEducations: 'contactEducations',
  contactEmploymentHistories: 'contactEmploymentHistories',
  contactEmploymentHistorySalaries: 'contactEmploymentHistorySalaries',
  contactTravelHistories: 'contactTravelHistories',
  contactRelationships: 'relationships',
  contactInsurances: 'contactInsurance',
};

export const EMPLOYEES_RELATED_ENTITIES = {
  contactAddresses: 'contactAddresses',
  contactCitizenships: 'contactCitizenships',
  contactIdentificationNumbers: 'contactIdentificationNumbers',
  contactEducations: 'contactEducations',
  contactEmploymentHistories: 'contactEmploymentHistories',
  contactEmploymentHistorySalaries: 'contactEmploymentHistorySalaries',
  contactTravelHistories: 'contactTravelHistories',
  contactRelationships: 'relationships',
  contactInsurances: 'contactInsurance',
};

export const ASSIGNMENT_RELATED_ENTITIES = {
  serviceInitServices: 'serviceInitiationServices',
};

export const DATE_FORMATS = {
  DATE_FORMAT_TO_SHOW: 'dd MMM yyyy',
  DISPLAY_DATE_ONLY: 'DD MMM YYYY',
  ISO8601_DATE_TIME: 'YYYY-MM-DD[T]hh:mm:ss[.mmm]TZD',
  ISO8601_DATE: 'YYYY-MM-DD',
};

export const SERVICE_TYPE = {
  SocialSecurity: 'SocialSecurity',
  Immigration: 'Immigration',
  PostedWorker: 'PostedWorker',
  Tax: 'Tax',
};

export const QUICKVIEWID_SUFFIX_BY_COUNTRY = {
  SocialSecurity: {
    suffix: 'ssn',
    displayText: 'Add new social security record',
  },
  Immigration: {
    suffix: 'immigration',
    displayText: 'Add new immigration record',
  },
};

export const SEARCH_ADD_PROPS = {
  ey_serviceinitiation: {
    ey_employeeapplicantid: {
      sortColumn: 'fullName',
      styleType: 'addEmployee',
      fetchLookupValues: fetchEmployeesApi,
      getFormData: fetchNewEmployeeFormData,
      saveFormData: saveEmployeeFormData,
    },
  },
  ey_contactemploymenthistory: {
    ey_employerid: {
      sortColumn: 'name',
      styleType: 'addEmployer',
      fetchLookupValues: fetchEmployersLookupValues,
      getFormData: getNewEmployerForm,
      saveFormData: createEmployer,
    },
  },
  ey_employmentprofileversion: {
    ey_employerid: {
      sortColumn: 'name',
      styleType: 'addEmployer',
      fetchLookupValues: fetchEmployersLookupValues,
      getFormData: getNewEmployerForm,
      saveFormData: createEmployer,
    },
  },
  incident: {
    ey_hostcompanyid: {
      sortColumn: 'name',
      styleType: 'addEmployer',
      fetchLookupValues: fetchEmployersLookupValues,
      getFormData: getNewEmployerForm,
      saveFormData: createEmployer,
    },
  },
};

export const TASK_COMPLETION_STATUS = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETE: 'Complete',
};

export const HIGH_LEVEL_BAR_HEIGHT = 35;

export const BAR_CHART = {
  FIXED_MARGIN_OFFSET: 40,
  MAX_LABEL_LENGTH: 15,
};

export const SERVICE_INITIATION_ATTRIBUTES = {
  VIP_EXECUTIVE: 'ey_vipexecutive',
};

export const TASK_TYPE = {
  UPCOMING_TRAVEL: 100000013,
};

export const EMAIL_REGEX = {
  //using the same regex which is used in CPS
  REGEX: /^([a-zA-Z0-9\-\.\'\w]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,20}|[0-9]{1,3})(\]?)$/, //eslint-disable-line
};

export const PHONE_REGEX = {
  //using the same regex which is used in CPS
  REGEX: /^[(|+|0-9][\s|0-9|(|)|-]{4,24}$/, //eslint-disable-line
};

export const MISSING_DATA_OVERVIEW_DETAILS = {
  TABS: {
    DATA_COLLECT: 0,
    OVERVIEW: 1,
  },
  MISSING: 'Missing',
  IS_ENABLE: false,
};

export const DATA_TYPE = {
  MY_DATA: 'My Data',
  ALL_DATA: 'All Data',
  MY_TASKS: 'My Tasks',
  TEAM_TASKS: 'Team Tasks',
};

export const EMAIL_ATTRIBUTE = {
  ATTRIBUTE_NAME: 'emailaddress1',
};

export const PHONE_ATTRIBUTE = {
  ATTRIBUTE_NAME: 'telephone1',
  HOME_PHONE_ATTRIBUTE_NAME: 'telephone2',
};

export const LOOKUP_ID = {
  PARENT_ID: 100000003,
  MATERNAL_GRANDPARENT_ID: 100000004,
  PATERNAL_PARENT_ID: 100000005,
};

export const MESSAGE_NAV_KEY = 'message_nav';
export const MESSAGE_NAV_CASE_NUMBER = 'message_nav_case_number';
export const DEFAULT_SESSION_KEY = 'default_view';
export const DEFAULT_TOGGLE_KEY = 'default_toggle';
export const DEFAULT_EMPLOYEE_KEY = 'default_employee';
export const DEFAULT_FORM_KEY = 'default_employeeform';
// m
export const DEFAULT_DASHBOARD_VIEW = {
  EXISTING: 'EXISTING',
  NEW: 'NEW',
};
export const CASE_DATA_MENUTYPES = {
  QUESTIONNAIRE: 1,
  DOCUMENTS: 2,
  REVIEW: 3,
};
export const DATE_REGEX = {
  DATE_TIME_AM_PM_REGEX: /^\d{1,2}\/\d{1,2}\/\d{4} \d{1,2}:\d{2} (AM|PM)$/, //eslint-disable-line
  DATE_ONLY_REGEX: /^\d{1,2}\/\d{1,2}\/\d{4}$/, //eslint-disable-line
  DATE_ONLY_REGEX_2: /^\d{4}-\d{1,2}-\d{1,2}$/, //eslint-disable-line
  DATE_TIME_REGEX: /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})Z$/, //eslint-disable-line
};

export const CONSENT_TYPES = {
  OTHER: 1,
  GDPC: 2,
};
